import {
  Inject,
  Injectable,
  OnInit
} from '@angular/core';
import {
  disable as disableDarkMode,
  enable as enableDarkMode
} from 'darkreader';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { ThemeColor } from '../enums/theme-color.enum';

@Injectable()
export class ColorThemeService implements OnInit {

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  public $colorTheme = new Subject<ThemeColor>();

  private localStorageKeyName = 'theme';

  public ngOnInit(): void {
    const colorTheme = this.getColorTheme() ?? ThemeColor.LIGHT;

    this.$colorTheme.next(colorTheme);

    if (colorTheme === ThemeColor.DARK) {
      this.switchColorTheme(true);
    }

    window.addEventListener('message', (event) => {
      if (event.data.message === 'toggleTheme') {
        this.switchColorTheme(event.data.value);
      }
    });

    window.parent.postMessage({message: 'initToggleTheme', value: this.getColorTheme()}, '*');

    if (window.location.href.includes('localhost') || window.location.href.includes('dashboard')) {
      this.switchColorTheme(false);
    }
  }

  private switchColorTheme(toggle: boolean): void {
    if (!toggle) {
      this.setColorTheme(ThemeColor.LIGHT);
      disableDarkMode();
      return;
    }

    this.setColorTheme(ThemeColor.DARK);
    enableDarkMode({
      brightness: 100,
      contrast: 90,
      sepia: 10,
    }, {
      invert: [],
      css: `.iv-switcher.active { background-color: #00AD80 } ` +
        `.iv-switcher { background-color: rgba(255, 99, 116, 0.9) } ` +
        `.checkmark { background-color: ${this.getColorTheme() === ThemeColor.DARK ? `#3F4040` : '#F1F2F7'} }` +
        `.dashboard-container { background-color: #fff; color: #000 !important; } ` + // ------- Отключение darkreadera для pages модуля ------------------------
        `.block { border: 1px solid #DDDDDD !important; background-color: white !important; } ` +
        `.block-label { background: linear-gradient(to right, #02dba3, #00AD80) !important; } ` +
        `.label-text { color: white !important } ` +
        `.services { background-color: white !important; border: 1px solid #DDDDDD !important; color: #337ab7 !important; } ` +
        `body { background-color: white } ` +
        // `::-webkit-scrollbar { background-color: #f1f1f1 !important; }` +
        // `::-webkit-scrollbar-thumb { background-color: #c1c1c1 !important; } ` +
        `.subscribe { color: #00AD80 !important } ` +
        `.subscribed { color: #545454 !important }` +
        `.compare { color: #fff !important }` +
        `.select-box-rewrite-bg { background-color: #fff !important } ` +
        `.label-form-field { color: #333 !important } ` +
        `.label-form-field-large { color: #333 !important } ` +
        `.data-cloud-my-download { color: #000 !important } ` +
        `.dx-popup-rewrite-bg { background-color: #fff !important } ` +
        `.text { color: rgb(229, 224, 216) !important } ` +
        `.header { color: #333333 !important } ` +
        `.package-block { border: 1px solid #DDDDDD !important; background-color: #fff !important } ` +
        `.group-name { color: #00AE80 !important } ` +
        `.doll { color: #787B86 !important } ` +
        `.text-cur { color: #787B86 !important } ` +
        `.text-prev { color: #787B86 !important }` +
        `.subscribedGroup { background-color: #ddf3f0 !important; border: 1px solid #00AD80 !important; } ` +
        `.subName { color: black !important } ` +
        `.label-with-text { border: 1px solid #00AD80 !important; color: #00AD80 !important; background: #fff !important; }` +
        `.dataset { background-color: #00ae80 !important; color: #ffffff !important; border: 1px solid #797979 !important; } ` +
        `.dx-radiobutton-icon::before { border: 1px solid #ddd !important; background-color: #fff !important; } ` +
        `.pagination__text { color: #000 !important; }` +
        `.pagination__page-number { background-color: #efefef !important; border-color: #ffffff !important; color: #000 !important; }` +
        `.button-in-light-theme { color: white !important; background-color: #00AD80 !important; border: 1px solid #00AD80 !important; }` +
        `.input-data-cloud { background-color: #fff !important } `, // -----------------------------------------------------------------------------------------
      ignoreInlineStyle: ['.block *', '.data-cloud-my-download *', '.ignore-darkreader *'],
      ignoreImageAnalysis: []
    });
  }

  public getColorTheme(): ThemeColor {
    return localStorage.getItem(this.localStorageKeyName) as ThemeColor;
  }

  private setColorTheme(colorTheme: ThemeColor): void {
    localStorage.setItem(this.localStorageKeyName, colorTheme);
    this.$colorTheme.next(colorTheme);
  }
}
